const actionSourceLabels: Record<string, string> = {
  confirmation_requirement: 'Specialist confirmation',
  information_request: 'Information request',
  approval_requirement: 'Approval requirement',
  ai_use_business_owner: 'AI Use business owner',
  ai_use_technical_owner: 'AI Use technical owner',
  organisation_ai_solution_technical_owner: 'Solution technical owner',
  control_assignment_owner: 'Control assignment owner',
  action_owner: 'Action owner',
  periodic_review_assignee: 'Periodic Review assignee',
  approval_condition_owner: 'Approval Condition owner',
  risk_owner: 'Risk owner',
  risk_acceptance_assignee: 'Risk Acceptance assignee',
  initiative_owner: 'Initiative owner',
  discovery_assignment: 'Discovery assignment',
  discovery_submission_contributor: 'Discovery submission contributor',
  candidate_clarification_recipient: 'Candidate Clarification recipient',
}

const stateLabels: Record<string, string> = {
  open: 'Open',
  waiting_on_others: 'Waiting on others',
  blocked: 'Blocked',
  pending_recipient: 'Pending recipient',
  unassigned: 'Unassigned',
  completed: 'Completed',
  draft: 'Draft',
  submitted: 'Submitted',
  in_progress: 'In progress',
  awaiting_response: 'Awaiting response',
  information_requested: 'Waiting for information',
  ready: 'Ready',
  pending: 'Pending',
  changes_requested: 'Changes requested',
  finalised: 'Completed',
  production: 'Production',
  pilot: 'Pilot',
  experiment: 'Experiment',
  proposed: 'Proposed',
  suspended: 'Suspended',
  retired: 'Retired',
  reassessment_required: 'Reassessment required',
  reassessment_in_progress: 'Reassessment in progress',
  reapproval_required: 'Reapproval required',
  not_started: 'Not started',
  not_ready: 'Not ready',
  not_required: 'Not required',
  not_applicable: 'Not applicable',
  awaiting_approval: 'Awaiting approval',
  reviewer_needs_assignment: 'Reviewer needs assignment',
}

const domainValueLabels: Record<string, string> = {
  model_or_ai_provider: 'Model or AI provider',
  model_provider: 'Model or AI provider',
  data_or_information: 'Data or information',
  data_information: 'Data or information',
  integration_or_system_access: 'Integration or system access',
  integration_system_access: 'Integration or system access',
  ai_behaviour_or_capability: 'AI behaviour or capability',
  ai_behaviour_capability: 'AI behaviour or capability',
  business_purpose_or_process: 'Business purpose or process',
  business_purpose_process: 'Business purpose or process',
  users_or_affected_people: 'Users or affected people',
  users_affected_people: 'Users or affected people',
  legal_professional: 'Legal or professional',
  approved_with_conditions: 'Approved with conditions',
  within_appetite: 'Within tolerance',
  within_tolerance: 'Within tolerance',
  approaching_appetite: 'Approaching tolerance',
  approaching_tolerance: 'Approaching tolerance',
  outside_appetite: 'Outside tolerance',
  outside_tolerance: 'Outside tolerance',
}

export function displayCode(value: string) {
  if (!value) return 'Not specified'
  return value.replaceAll('_', ' ').replace(/^./, (letter) => letter.toUpperCase()).replaceAll('Ai ', 'AI ')
}

export function actionSourceLabel(value: string) {
  return actionSourceLabels[value] ?? displayCode(value)
}

export function stateLabel(value: string) {
  return stateLabels[value] ?? displayCode(value)
}

export function displayDomainValue(value: unknown, fallback = 'Not specified') {
  if (typeof value !== 'string' || !value.trim()) return fallback
  return domainValueLabels[value] ?? stateLabels[value] ?? displayCode(value)
}

export function governanceStageLabel(stage: string, state: string) {
  if (stage === 'assess' && state === 'in_progress') return 'Assessment in progress'
  if (stage === 'assess' && state === 'reassessment_in_progress') return 'Reassessment in progress'
  return stateLabel(state)
}

export function actionDescription(value: string) {
  if (value === 'Review the recorded Assessment facts and provide your specialist determination.') {
    return 'Review the assessment information and record your response.'
  }
  return value
}

export function governanceTierLabel(value: unknown) {
  const tier = typeof value === 'number' || typeof value === 'string' ? String(value).trim() : ''
  return tier ? `Tier ${tier.replace(/^tier[\s_-]*/i, '')}` : 'Not specified'
}
